import React, { useEffect, useState } from "react";
import { Loader2, Sparkles, Lightbulb, Send } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/api";
import { useFavorites } from "@/hooks/useFavorites";
import { StickerGrid } from "@/components/StickerGrid";

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return "";
  }
}

export function Novidades() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { favIds, onToggleFav } = useFavorites();

  useEffect(() => {
    api.get("/novidades").then((res) => setData(res.data)).finally(() => setLoading(false));
  }, []);

  if (loading)
    return (
      <div className="py-24 flex justify-center">
        <Loader2 className="animate-spin text-[#C58B90]" size={32} />
      </div>
    );

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Sparkles className="text-[#C58B90]" size={26} />
        <h1 className="font-serif text-3xl">Novidades</h1>
      </div>
      <p className="text-sm text-[#7A7571]">Atualizado em: {formatDate(data?.updated_at)}</p>
      {data?.notice && (
        <div
          className="rounded-3xl px-5 py-4"
          style={{ background: "linear-gradient(120deg,#F2E6E7,#E8CFD1)" }}
          data-testid="novidades-notice"
        >
          <p className="text-sm text-[#8A5F63] font-medium">{data.notice.message}</p>
        </div>
      )}
      <StickerGrid stickers={data?.stickers || []} favIds={favIds} onToggleFav={onToggleFav} />
    </div>
  );
}

export function Suggestions() {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setLoading(true);
    try {
      const res = await api.post("/suggestions", { text });
      toast.success(res.data.message);
      setText("");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto space-y-6">
      <div className="flex items-center gap-2">
        <Lightbulb className="text-[#C58B90]" size={26} />
        <h1 className="font-serif text-3xl">Sugira um Sticker</h1>
      </div>
      <p className="text-[#7A7571]">
        Tem uma ideia de sticker ou tema? Conta pra gente! A Brenda adora saber o que você quer ver por aqui 💗
      </p>
      <form onSubmit={submit} className="bg-white rounded-3xl p-6 border border-[#F2E6E7] bc-shadow-soft space-y-4">
        <textarea
          data-testid="suggestion-text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={5}
          placeholder="Ex: adorava um pack de stickers de viagem ✈️ ou frases de gratidão…"
          className="w-full rounded-2xl bg-[#FCFBF9] border border-[#E8CFD1] p-4 outline-none focus:border-[#C58B90] focus:ring-2 focus:ring-[#F2E6E7] transition-[border-color,box-shadow] resize-none text-sm"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="suggestion-submit"
          className="w-full h-12 rounded-full bg-[#C58B90] text-white font-semibold flex items-center justify-center gap-2 hover:bg-[#A87277] transition-colors disabled:opacity-70"
        >
          {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={17} />}
          Enviar sugestão
        </button>
      </form>
    </div>
  );
}
